$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-arbiter-2-rta');
})
$('.pnr_cart').click(function(){
    var element = document.querySelector(".sec-8");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".sec-9");
    element.scrollIntoView({block: "end"});
})

// section 2 img-slider

window.onload = (event) => {

    if(window.width < 851){
            
        const sec2img = document.querySelector('.sec2__img-slide');
        let transXval = -27.2;
        sec2img.style.transform = `translateX(${transXval}%)`;
    
    
    
        // get gesture
        let touchstartX = 0;
        let touchstartY = 0;
        let touchendX = 0;
        let touchendY = 0;

        const gestureZone = sec2img;

        gestureZone.addEventListener('touchstart', function(event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        }, false);

        gestureZone.addEventListener('touchend', function(event) {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleGesture();
        }, false); 


        // slide changes
        function handleGesture() {
            if (touchendX <= touchstartX) {
                if(transXval === -27.2){
                    transXval = -43;
                    sec2img.style.transform = `translateX(${transXval}%)`
                }
                if(transXval === -11.8){
                    transXval = -27.2;
                    sec2img.style.transform = `translateX(${transXval}%)`
                }
            }
            
            if (touchendX >= touchstartX) {
                if(transXval === -27.2){
                    transXval = -11.8;
                    sec2img.style.transform = `translateX(${transXval}%)`
                }
                if(transXval === -43){
                    transXval = -27.2;
                    sec2img.style.transform = `translateX(${transXval}%)`
                }
                
                }
            }
        };
};


//section9
const allIcons = document.querySelectorAll('.xlimc_section9 .glide__bullet');


// event listeners
allIcons.forEach(el =>{
    el.addEventListener('mouseenter', ()=>{
        el.closest(".glide__bullet").click();
    });
});
new Glide('.glide',{
    gap: 0
}).mount();

var controller1 = new ScrollMagic.Controller();

var box9_package_info=document.getElementsByClassName('box9_package_info');
var box9_buttonlist=document.getElementsByClassName('box9_buttonlist');

let scene9 = new ScrollMagic.Scene({
      offset: 0,
      triggerElement: ".origin_mini-sec10",
      triggerHook: "onenter",
      duration: 0
  });
  scene9.on("progress", function (event) {
      for (var i = 0; i < box9_package_info.length; i++) {
        box9_package_info[i].classList.add("showup");
      }

      box9_buttonlist[0].classList.add("showup"); 

      var index=event.progress.toFixed(3) * 100;
      if(index<2){
      for (var j = 0; j < box9_package_info.length; j++) {
        box9_package_info[j].classList.remove("showup");
      }
      box9_buttonlist[0].classList.remove("showup");
      }
  }); 

  controller1.addScene([scene9]);

